import Component from '@glimmer/component';
import { type EventInfoComponentArgs } from 'donor-elf-web/components/event/index';
import formatDate from 'donor-elf-web/helpers/format-date';
import formatAmount from 'donor-elf-web/helpers/format-amount';

export default class EventInfoReturningLateDonorComponent extends Component<EventInfoComponentArgs> {
  <template>
    <div>
      They used to be a late donor but have started giving again on {{formatDate
      @eventModel.occurredAt}}. They last gave {{formatAmount
      @eventModel.custom.last_donation_amount removeNoCents=true}} on
      {{formatDate @eventModel.custom.last_donation_date}}.
    </div>
  </template>
}
